import { BaseFormInsertProps, FormInsertData } from "@boilerplate/types/entity";
import LoggedHourEntity from ".";
import LoggedHourBaseInsertForm from "@/_base/loggedHour/components/LoggedHourBaseInsertForm";
import { useMemo } from "react";
import { useAuthenticatedUserStore } from "@/stores/UserStore";

function LoggedHourInsertForm({ formOnly = false, onClose, Entity = LoggedHourEntity, ...props }: BaseFormInsertProps<typeof LoggedHourEntity.model>) {
    const currentUser = useAuthenticatedUserStore();
    const hiddenFields: (keyof FormInsertData<typeof LoggedHourEntity.model>)[] = useMemo(() => {
        if (currentUser.isSuperAdmin) {
          return [];
        }
    
        return ['createdAt', 'updatedAt'];
      }, [currentUser.isSuperAdmin]);

    return <LoggedHourBaseInsertForm {...props} onClose={onClose} Entity={Entity} formOnly={formOnly} hiddenFields={hiddenFields} />;
}

export default LoggedHourInsertForm;